import { Routes } from '@angular/router';
import { NotificationsComponent } from '../../infrastructure/shared/components/notifications/notifications';
import { ClientAppointmentForm } from '../../infrastructure/shared/components/client-appointment-form/client-appointment-form';
import { ClientAppointmentsCalendar } from '../../infrastructure/shared/components/client-appointments-calendar/client-appointments-calendar';
import { IndividualAppointmentsPage } from './individual-appointments-page/individual-appointments-page';
import { IndividualPackagesPage } from './individual-packages-page/individual-packages-page';
import { IndividualSettings } from './individual-settings/individual-settings';

export const individualRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'appointments',
      },
      {
        path: 'appointments',
        component: IndividualAppointmentsPage,
      },
      {
        path: 'calendar',
        component: ClientAppointmentsCalendar,
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
      },
      {
        path: 'appointments/create',
        component: ClientAppointmentForm,
        data: { fullWidth: true },
      },
      {
        path: 'packages/offer',
        component: IndividualPackagesPage,
      },
      {
        path: 'settings',
        component: IndividualSettings,
      },
      { path: '**', redirectTo: 'appointments' },
    ],
  },
  { path: '**', redirectTo: 'appointments' },
];
